import React from 'react';

const Account: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Аккаунт</h1>
      <p>Настройки аккаунта</p>
    </div>
  );
};

export default Account;
